import { FC } from 'react'
import { memo } from 'react'
import sclasses from '../SetCourseClassDirectionModal/index.module.css'
import spclasses from '../SetCourseClassDirectionModal/purchase.module.css'
import cn from 'classnames'
import { Lead } from '@/api/types/crm.types'
import { InputNew } from '@UI/InputNew'
import {
  getLeadField,
  getLeadFieldValue,
} from '@pages/Admin/CRM/utils/leadFields'
import { useGetExtraPurchaseFields } from '@pages/Admin/PlatformSettings2/DirectorySettings/components/ExtraPurchaseFields/utils'

const UserFields: FC<{ lead: Lead }> = memo(({ lead }) => {
  const { extraFields } = useGetExtraPurchaseFields()
  const parentNameField = getLeadField(lead, 'PARENTNAME')
  const parentEmailField = getLeadField(lead, 'PARENTEMAIL')
  const parentPhoneField = getLeadField(lead, 'PARENTPHONE')

  return (
    <>
      <p className={sclasses.textDescription}>
        {lead.user
          ? 'У этого лида уже есть личный кабинет'
          : 'У этого лида пока нету личного кабинета, он будет создан при покупке'}
      </p>
      {!lead.user_id && extraFields.includes('studentName') && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="ФИО учащегося"
            value={lead.user?.name || getLeadFieldValue(lead, 'NAME')}
          />
        </div>
      )}
      {!lead.user_id && extraFields.includes('studentEmail') && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="E-mail учащегося"
            value={lead.user?.email || getLeadFieldValue(lead, 'EMAIL')}
          />
        </div>
      )}
      {!lead.user_id && extraFields.includes('studentPhone') && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="Номер телефона учащегося"
            value={lead.user?.phone || getLeadFieldValue(lead, 'PHONE')}
          />
        </div>
      )}
      {extraFields.includes('parentName') && parentNameField?.is_active && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="ФИО родителя"
            value={parentNameField?.value || ''}
          />
        </div>
      )}
      {extraFields.includes('parentEmail') && parentEmailField?.is_active && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="E-mail родителя"
            value={parentEmailField?.value || ''}
          />
        </div>
      )}
      {extraFields.includes('parentPhone') && parentPhoneField?.is_active && (
        <div className={sclasses.inputWithLabel}>
          {/* @ts-ignore */}
          <InputNew
            disabled={true}
            className={cn(spclasses.input, spclasses.disabledInput)}
            title="Номер телефона родителя"
            value={parentPhoneField?.value || ''}
          />
        </div>
      )}

      {(!lead.user_id ||
        extraFields.includes('parentName') ||
        extraFields.includes('parentEmail') ||
        extraFields.includes('parentPhone')) && (
        <p className={sclasses.textSmallDescription}>
          * вы можете обновить эту информацию в карточке лида
        </p>
      )}
    </>
  )
})

export default UserFields
